import state from './userEdit.state'
import mutations from './userEdit.mutations'
import actions from './userEdit.actions'
import getters from './userEdit.getters'

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
